module.exports = __webpack_public_path__ + "img/Capsule.8785bd4a.svg";